import { render } from "./GatewayForm.vue?vue&type=template&id=13ae9fb2"
import script from "./GatewayForm.vue?vue&type=script&lang=js"
export * from "./GatewayForm.vue?vue&type=script&lang=js"
script.render = render

export default script